import { AfterViewInit, Component, ElementRef, Input, Renderer, ViewChild, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'pui-column',
  templateUrl: 'column.component.html'
})
export class PuiColumnComponent implements AfterViewInit, OnChanges {
  @Input() cols: number;
  @Input('options') options: any = {};
  @ViewChild('column') column: ElementRef;

  constructor(public element: ElementRef, public renderer: Renderer) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['cols']) {
      this.ngAfterViewInit();
    }
  }

  ngAfterViewInit() {
    // set default
    const max = 12;
    let xs: number = this.cols ? this.cols : max;
    let sm: number = this.cols ? this.cols : max;
    let md: number = this.cols ? this.cols : max;
    let lg: number = this.cols ? this.cols : max;

    if (this.options['xs']) {
      xs = this.options['xs'];
    }

    if (this.options['sm']) {
      sm = this.options['sm'];
    }
    if (this.options['md']) {
      md = this.options['md'];
    }

    if (this.options['lg']) {
      lg = this.options['lg'];
    }

    this.renderer.setElementAttribute(this.column.nativeElement, 'class', `col-xs-${xs} col-sm-${sm} col-md-${md} col-lg-${lg}`);
  }
}
